// Compiled at 2026-09-18T12:45:23.821Z
// Auto-generated by Lowgile
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import type { OnAfterCodeLoad } from "@lg/shared";
import { BoInfoSymbol, HasChangedInternallySymbol } from "@lg/shared/for-apps";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty } from "@sumbricht/json-class-serializer";
import { proxySignal, ProxySignal, signal, computed, Signal } from "../../signals.js";
import { HasSignalProperties } from "@lg/shared/for-apps";
import { immerable } from "immer";
import { DataLoader } from "@lg/shared/for-apps";
import { Subject } from "rxjs";
import { z } from "zod";
import { AppContext } from "@lg/ng-shared";
import { ChangeDetectorRef } from "@angular/core";

const θdataLoader =
    new DataLoader(() => VendorMaterial.loadInternal(), entryList => {
        VendorMaterial.θentryList.set(entryList)
        VendorMaterial.θonEntryListUpdated()
    }, { doCache: true, expireAfterMs: 0 })
    ;

// Auto-generated by Lowgile
export class VendorMaterial {
    readonly [BoInfoSymbol] = Object.freeze({
        boType: "StaticEntity" as const,
        editablePropertyNames: ["id"] as const,
        computedPropertyNames: ["supplierId", "materialName"] as const,
        allPropertyNames: ["id", "supplierId", "materialName"] as const,
        propertyNamesOfInterest: [] as const,
    });
    readonly [HasSignalProperties] = true;
    readonly [HasChangedInternallySymbol] = new Subject<void>();
    readonly θid: ProxySignal<VendorMaterial.Id | null>;
    static readonly Id = Number;
    static ids: VendorMaterial.Id[] = [] as any;
    static idsAndDisplayValues: Record<VendorMaterial.Id, string> = {} as any;
    static θentryList = signal<VendorMaterial.Entry[] | undefined>(this.θgetStaticEntryList());
    static θentryMap = computed(() => {
        const objEntries = this.θentryList()?.map(e => [e.id, e]) ?? []
        return Object.freeze(Object.fromEntries(objEntries))
    });
    static θchoicesCache = new Map<string, Sys.Types.Choice[]>();
    static θfilteredCache = new Map<string, Signal<VendorMaterial.Entry[]>>();
    readonly θhasOthers = false;
    static readonly $displayProperty = 'materialName';
    [immerable] = true;
    readonly θsupplierId = computed(() => {
        const id = this.θid()
        return id !== null ? VendorMaterial.getEntryMap()[id]?.supplierId : undefined
    });
    readonly θmaterialName = computed(() => {
        const id = this.θid()
        return id !== null ? VendorMaterial.getEntryMap()[id]?.materialName : undefined
    });
    readonly $isOther = false;

    static get [BoInfoSymbol]() {
        return VendorMaterial[BoInfoSymbol]
    }

    get __type(): 'Orders.VendorMaterial' {
        return 'Orders.VendorMaterial'
    }

    set __type(_) {
    }

    static get __type(): 'Orders.VendorMaterial' {
        return 'Orders.VendorMaterial'
    }

    static set __type(_) {
    }

    @jsonProperty()
    get id(): VendorMaterial.Id | null {
        return this.θid()
    }

    set id(id: VendorMaterial.Id | VendorMaterial | null) {
        if (id !== null && typeof id == 'object') { id = id.id }



        this.θid.set(id as VendorMaterial.Id | null)
        this[HasChangedInternallySymbol].next()
    }

    get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    static get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    get ids(): VendorMaterial.Id[] {
        return VendorMaterial.ids
    }

    get idsAndDisplayValues(): Record<VendorMaterial.Id, string> {
        return VendorMaterial.idsAndDisplayValues
    }

    get $displayValue(): string {
        return this.$isOther ? (this as any).$other : String((this as any)[VendorMaterial.$displayProperty])
    }

    get supplierId() {
        return this.θsupplierId()
    }

    get materialName() {
        return this.θmaterialName()
    }

    constructor(idOrObject: VendorMaterial.Id | VendorMaterial | null = null) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid = proxySignal(id)

    }

    getEntryList(filters?: { entryProperty: string, values: any[] }[]): VendorMaterial.Entry[] {
        return This.VendorMaterial.getEntryList(filters)
    }

    static getEntryList(filters?: { entryProperty: string, values: any[] }[]): VendorMaterial.Entry[] {
        if (filters) {
            const key = JSON.stringify(filters)
            let filteredList = this.θfilteredCache.get(key)
            if (!filteredList) {
                filteredList = computed(() => this.θentryList()?.filter(entry => filters.every(filter => filter.values.includes(entry[filter.entryProperty]))) ?? [])
                this.θfilteredCache.set(key, filteredList)
            }

            return filteredList()
        }

        return this.θentryList()
    }

    static getEntryMap() {
        return this.θentryMap()
    }

    static getEntry(id: VendorMaterial.Id) {
        const entryMap = this.getEntryMap()
        return entryMap[id]
    }

    static getChoices(labelColumn: keyof VendorMaterial.Entry = '$displayValue'): Sys.Types.Choice[] {
        if (labelColumn == "$displayValue") labelColumn = VendorMaterial.$displayProperty
        let options = this.θchoicesCache.get(labelColumn)
        if (!options) {
            const entryList = this.getEntryList() ?? []
            options = entryList.map(entry => ({ id: entry.id, label: String(entry[labelColumn]), $isOther: false }))
            this.θchoicesCache.set(labelColumn, options)
        }

        return options
    }

    static async load(forceReload = false) {
        if (forceReload) {
            this.θentryList.set(await θdataLoader.forceReloadAndGetData())
        } else {
            this.θentryList.set(await θdataLoader.waitAndGetValidData())
        }

        this.θonEntryListUpdated()
        return this.θentryList()
    }

    static async loadInternal(): Promise<VendorMaterial.Entry[]> {
        async function getDynamicEntries() {
            try {
                return ExecutionService.executeMethodAndReturnData<any[]>('StaticEntity', 'Orders', 'VendorMaterial', undefined, 'getEntryList', [])
            } catch (err: any) {
                console.error('Error loading dynamic entries for Orders.VendorMaterial:', err)
                return []
            }

        }

        const dynamicEntryList = await getDynamicEntries()
        this.θchoicesCache.clear()
        return createReadonlyProxy(true, [...this.θgetStaticEntryList(), ...dynamicEntryList])
    }

    toJSON() {
        return this.id
    }

    $clone() {
        return new VendorMaterial(this.id)
    }

    $equals(other: any) {
        if (this.id !== other?.id) return false

        return true
    }

    θtoPlainObject() {
        return this.id
    }

    θtoIdAndOther(idOrObject: VendorMaterial.Id | VendorMaterial | null) {
        if (idOrObject && typeof idOrObject == 'object') {
            return { id: idOrObject.id }

        } else {
            return { id: idOrObject as VendorMaterial.Id | null, otherValue: '' }

        }
    }

    θupdate(idOrObject: VendorMaterial.Id | VendorMaterial) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid.set(id)

    }

    static θonEntryListUpdated() {
        this.ids = this.getEntryList().map(e => e.id)
        this.idsAndDisplayValues = Object.fromEntries(this.getEntryList().map(e => [e.id, e.$displayValue] as const)) as Record<VendorMaterial.Id, string>
        AppContext.resolve(ChangeDetectorRef).detectChanges()
    }

    static async θafterCodeLoad() {
        return this.load().catch(err => {
            console.log('Could not load entries of StaticEntity Orders.VendorMaterial yet:', err.message)
            //throw err
        })
    }

    static θgetStaticEntryList() {
        return Object.freeze([

        ] as VendorMaterial.Entry[]) as VendorMaterial.Entry[]
    }
}
jsonClass('Orders.VendorMaterial')(VendorMaterial)

export const VendorMaterialθId = Number;

export type VendorMaterialθId = number;

export namespace VendorMaterial {
    export type Id = number

    export interface Entry {
        id: VendorMaterial.Id;
        supplierId: number;
        materialName: string;
        $displayValue?: string;
    }
}
Sys.Language.languageChanged$.subscribe(() => VendorMaterial.load(true))
